<template>
  <span
    class="py-1.5 px-4 bg-gray-96 group-hover:bg-white text-xs text-dlubal-blue rounded-2xl duration-300 transition-colors ease-in-out"
  >
    <span class="mt-[1px]">
      <slot></slot>
    </span>
  </span>
</template>

<script setup lang="ts"></script>
